/**
 * Created by DynamicDog on 2016-12-13.
 *
 * View for the final step.
 * Allows the user to select the layout of the page.
 * Also shows all the created etiketts.
 * TODO: Work on mail functionality.
 */

import {Component} from '@angular/core';
import {EtikettService} from "../services/etikett.service";
import {DialogsService} from "../dialogs/email.service";
import { saveAs } from 'file-saver';
@Component({
    selector: 'print-view',
    template: `
            <div id="print-view">
                <div class="header"><span class="number">3</span>{{'Välj storlek & antal'|translate}}</div>
                <h2>{{'Välj utskriftsformat'|translate}}</h2>
                <h3>{{'(antal etiketter per A4)'|translate}}</h3>
                <div class="menu">
                    <div class="printsize menu-item clickable" id="large" (click)="onClick('large')" [ngClass]="{selected: etikettService.getPrintSize()==='large'}">
                        <div style="font-weight:bolder;text-transform:uppercase">{{'stor'|translate}}</div>
                        <div style="font-weight:lighter">{{etikettService.largeCountString|translate}}</div>
                        <div style="font-weight:lighter">{{etikettService.largeSizeString|translate}}</div>
                    </div>
                    <div class="printsize menu-item clickable" id="medium" (click)="onClick('medium')" [ngClass]="{selected: etikettService.getPrintSize()==='medium'}">
                        <div style="font-weight:bolder;text-transform:uppercase">{{'medel'|translate}}</div>
                        <div style="font-weight:lighter">{{etikettService.mediumCountString|translate}}</div>
                        <div style="font-weight:lighter">{{etikettService.mediumSizeString|translate}}</div>
                    </div>
                    <div class="printsize menu-item clickable" id="small" (click)="onClick('small')" [ngClass]="{selected: etikettService.getPrintSize()==='small'}">
                        <div style="font-weight:bolder;text-transform:uppercase">{{'liten'|translate}}</div>
                        <div style="font-weight:lighter">{{etikettService.smallCountString|translate}}</div>
                        <div style="font-weight:lighter">{{etikettService.smallSizeString|translate}}</div>
                    </div>
                </div>
                <h2>{{'Välj antal'|translate}}</h2>
                <h3>{{'Välj antal etiketter totalt'|translate}}</h3>
                <etikett-spinner *ngFor="let etikett of etikettService.getEtiketter(); let i = index" [etikett]="etikett" [index]="i"></etikett-spinner>
				<div style="padding-bottom:99px;padding-top:32px">
					<div class="button clickable" style="margin-bottom:10px" (click)="onDownload()">{{'Ladda ner'|translate}}</div>
                    <div class="button clickable" style="margin-bottom:10px" (click)="onPrint()">{{'Skriv ut'|translate}}</div>
                    <div class="button clickable" (click)="onMail()">{{'Maila'|translate}}</div>
                </div>

            </div>
        `,
})

export class PrintViewComponent {
    private largeCountString:string;
    private mediumCountString:string;
    private smallCountString:string;

    private largeSizeString:string;
    private mediumSizeString:string;
    private smallSizeString:string;

    constructor(private etikettService:EtikettService,private email:DialogsService) {

	}
	
	private isEdgeOrIe() {

	}

    private onClick(size:string) {
        this.etikettService.setPrintSize(size);
    }

    private onMail():void {
        this.email.compose();
    }

    // Send the designs to the pdf creater
    private onPrint(): void {
        var _this = this;
        this.etikettService.setBusy(true);
        this.etikettService.createPDF().then(
            function(uuid:string) {
                window.open(_this.etikettService.server+"projects/"+uuid+"/etikett.pdf","_self");
                _this.etikettService.setBusy(false);
            }, function(err) {
                _this.etikettService.setBusy(false);
                console.warn("createPDF failed ",err);
            }
        );
	}
	
    private onDownload(): void {
        var _this = this;
        this.etikettService.setBusy(true);
        this.etikettService.createPDF().then(
            function(uuid:string) {
//                window.open(_this.etikettService.server+"projects/"+uuid+"/etikett.pdf","_self");
				var xhr = new XMLHttpRequest();
				xhr.open('GET', _this.etikettService.server+"projects/"+uuid+"/etikett.pdf", true);
				xhr.responseType = 'blob';
			
				xhr.onload = function(e) {
  					if (this.status == 200) {
    					var myBlob = this.response;
						// myBlob is now the blob that the object URL pointed to.
						saveAs(myBlob, 'etikett.pdf');
						_this.etikettService.setBusy(false);
  					}
				}
			
				xhr.send();
//				saveAs(new Blob(['sven'], { type: "text" }), 'data.txt');
				
				
            }, function(err) {
                _this.etikettService.setBusy(false);
                console.warn("createPDF failed ",err);
            }
        );
	}
}





// WEBPACK FOOTER //
// ./app/print/print.view.ts